<template>
  <div class="adviser-enrolment-wrapper">
    <div class="adviser-enrolment-content">
      <div class="mb-12 boost-earnings-section">
        <h1>Boost Your Earnings With Will Services</h1>
        <p>
          <strong>During April 2025, Old Mutual Will gives you:</strong>
        </p>
        <ul>
          <li>
            R750 (pre-tax) for each validated and signed will that you complete
            on behalf of your clients.
          </li>
          <li>A new way to add value to client relationships.</li>
          <li>A simple tool to help identify estate planning opportunities.</li>
          <li>Support from our dedicated team throughout the process.</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdviserEnrolmentAccentuatedContent",
  data() {
    return {};
  },
  methods: {},
  computed: {
    isMobile() {
      return this.$isMobileDevice();
    },
  },
};
</script>

<style scoped lang="scss">
.adviser-enrolment-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
}

.adviser-enrolment-content {
  width: 100%;
  max-width: 768px;
  justify-self: center;
  position: relative;
  z-index: 1;
}

section {
  margin-bottom: 60px;
}

.semi-bold {
  font-weight: 600 !important;
}
.article-link {
  color: #282828;
  font-weight: 500;
}

h1 {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-style: normal;
  font-size: 28px;
  line-height: 34px;
  margin-bottom: 24px;
  &.intro {
    font-size: 22px;
    font-weight: 400;
    line-height: 26px;
  }
}
h2 {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-style: normal;
  font-size: 22px;
  line-height: 26px;
  margin: 40px 0 24px 0;
  &.sub-heading-one {
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
  }
  &.sub-heading-two {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }
  &.om-green {
    color: #50b848;
  }
}

.article-cta {
  color: #50b848;
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  a {
    color: #50b848;
    font-family: "Montserrat", sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
  }
}
p,
ul,
li {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  line-height: 22px;
}
blockquote {
  color: #50b848;
  border-left: 4px solid #50b848;
  padding-left: 24px;
  font-size: 22px;
  font-weight: 400;
  line-height: 26px;
  text-align: left;
  margin: 40px 0;
  ul {
    li {
      list-style-type: disc;
      font-family: "Montserrat", sans-serif;
      font-size: 16px;
      font-weight: 400;
      line-height: 28px;
      text-align: left;

      &::marker {
        color: #50b848;
      }
    }
    p {
      color: #282828;
      font-family: "Montserrat", sans-serif;
      font-weight: 400;
      font-style: normal;
      font-size: 16px;
      line-height: 22px;
    }
    &.no-paragraphs {
      li {
        color: #282828;
      }
    }
  }
}
ul {
  margin: 24px 0;
  p {
    margin: 10px 0;
  }
}

.faq-category {
  margin-bottom: 40px;

  .faq-item {
    margin-bottom: 24px;
  }
}
</style>
